var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"edge-top-slice","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Крышка_Срез"}},[_c('rect',{staticClass:"tsl-c-3",style:({ fill: _vm.params.sliceColor }),attrs:{"x":"44.68","y":"227.89","width":"437.31","height":"4.52","rx":"1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }